module.exports = __webpack_public_path__ + "static/media/heart-square.8c3f3221.svg";